export class ModalService {
  public open(id: string): void {
    const modal = document.getElementById(id);

    if (!modal) {
      return;
    }

    modal.style.display = 'block';
    document.body.classList.add('modal-open');
  }

  public close(id: string): void {
    document.body.classList.remove('modal-open');

    const modal = document.getElementById(id);

    if (!modal) {
      return;
    }

    modal.style.display = 'none';
  }
}
